<div class="container">
  <section class="contact-us">
    <div class="main-title">
      <span class="text-hover-animation">Связаться с нами</span>
    </div>
    <div class="contact-us-row">
      <img class="contact-us-img" src="assets/img/contact-us-img.svg" alt="image">
      <div class="contact-us-container">
        <div class="contact-us-item">
          <div class="contact-us-item-sub-container">
            <p class="contact-us-item-title">Витебск, Борисов, Брест, Жодино, Могилев, Молодечно, Орша, Пинск, Барановичи, Гродно,
              Полоцк, Светлогорск</p>
            <div class="contact-us-item-container">
              <img src="../../../../assets/img/contact/contact-us-telegram.svg" alt="icon">
              <a class="contact-us-link" href="https://t.me/busyfly2023">busyfly2023</a>
            </div>
            <div class="contact-us-item-container">
              <img src="../../../../assets/img/contact/contact-us-whatsup.svg" alt="icon">
              <a class="contact-us-link" href="https://wa.me/375292455545">375292455545</a>
            </div>
            <div class="contact-us-item-container">
              <img src="../../../../assets/img/contact/contact-us-viber.svg" alt="icon">
              <a class="contact-us-link" href="viber://add?number=375292455545">+375292455545</a>
            </div>
          </div>
          <div class="contact-us-item-sub-container">
            <p class="contact-us-item-title">Гомель, Бобруйск, Новополоцк</p>
            <div class="contact-us-item-container">
              <img src="../../../../assets/img/contact/contact-us-phone.svg" alt="icon">
              <a class="contact-us-link" href="tel:375298456559">375298456559</a>
            </div>
          </div>
          <div class="contact-us-item-sub-container">
            <p class="contact-us-item-title">Минск</p>
            <div class="contact-us-item-container">
              <img src="../../../../assets/img/contact/contact-us-mail.svg" alt="icon">
              <a class="contact-us-link" href="mailto:support@busy-fly.com">support@busy-fly.com</a>
            </div>
          </div>
        </div>
        <div class="contact-us-item">
          <p class="contact-us-item-description">ООО "Бизи-Флай систем" <br> Юридический адрес: Республика Беларусь,
            220092, г. Минск, ул. Берута 3Б,
            пом.85,
            ком.19</p>
          <p class="contact-us-item-description"> УНП: 193537642 <br> ОКПО: 505009725000</p>
        </div>
      </div>
    </div>
  </section>
</div>
